import { RecordingType } from "../../../../../types/general-types";
import i18n from "../../../../../i18n";
import styles from "./VideoLabel.module.css";

export type RecordingLabelType = RecordingType | "microphone";

export default function VideoLabel({ type, index }: { type: RecordingLabelType; index?: number }) {
	const text =
		i18n.t(`result.components.studentSelection.videoPlayer.videoLabel.${type}`) +
		(index == null ? "" : ` ${index + 1}`);
	return <div className={styles.label}>{text}</div>;
}
